"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZendeskDepartmentId = exports.ZendeskDepartment = void 0;
var ZendeskDepartment;
(function (ZendeskDepartment) {
    ZendeskDepartment["CH_CHAT_SUPPORT"] = "CH Chat Team";
    ZendeskDepartment["OG_CHAT_SUPPORT"] = "OG Chat Team";
    ZendeskDepartment["PARTNER_CHAT_SUPPORT"] = "Partner Support Chat Team";
    ZendeskDepartment["MERCHANT_CHAT_SUPPORT"] = "Merchant Support Chat Team";
})(ZendeskDepartment || (exports.ZendeskDepartment = ZendeskDepartment = {}));
var ZendeskDepartmentId;
(function (ZendeskDepartmentId) {
    ZendeskDepartmentId[ZendeskDepartmentId["CH_CHAT_SUPPORT"] = 21588859909773] = "CH_CHAT_SUPPORT";
    ZendeskDepartmentId[ZendeskDepartmentId["OG_CHAT_SUPPORT"] = 21588866828685] = "OG_CHAT_SUPPORT";
    ZendeskDepartmentId[ZendeskDepartmentId["PARTNER_CHAT_SUPPORT"] = 45477503576973] = "PARTNER_CHAT_SUPPORT";
    ZendeskDepartmentId[ZendeskDepartmentId["MERCHANT_CHAT_SUPPORT"] = 47553626950413] = "MERCHANT_CHAT_SUPPORT";
})(ZendeskDepartmentId || (exports.ZendeskDepartmentId = ZendeskDepartmentId = {}));
